export enum ChallengeStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export interface WeeklyPackChallenge {
  week_start: string;
  days_completed: string[];
  notification_sent: boolean;
  status: ChallengeStatus;
  progress: Record<string, any>;
  raw_data: Record<string, Record<string, number>>;
}

export interface CurrentPromotionChallengeWeek {
  week_start: string;
  days_completed: string[];
  status: ChallengeStatus;
  raw_data: Record<string, Record<string, number>>;
}

export interface PreviousPromotionChallengeWeek {
  week_start: string;
  status: ChallengeStatus;
}

export interface PromotionChallenge {
  current_week: CurrentPromotionChallengeWeek;
  previous_week: PreviousPromotionChallengeWeek | null;
}

export interface ChallengeProgress {
  weekly_pack_challenge: WeeklyPackChallenge;
  promotion_challenge: PromotionChallenge;
}
